module.exports = __webpack_public_path__ + "img/ai-back-mob.31c4969b.svg";